var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSeparator = function SvgSeparator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.848 16.328v-1.106l4.578-1.988-4.578-1.974v-1.12l5.754 2.618v.952l-5.754 2.618z",
    fill: "#9E9E9E"
  })));
};
export default __webpack_public_path__ + "static/media/separator.d743ea48.svg";
export { SvgSeparator as ReactComponent };